import { FCAdditionalProps, useOutsideClick } from "@datassential/platform-ui-lib";
import { useMemo, useRef, useState } from "react";
import cn from "classnames";
import { IOption } from "@models";
import { MdKeyboardArrowDown } from "react-icons/md";

type Props<T> = FCAdditionalProps & {
    options: IOption<T>[];
    value: T | null;
    otherValue: T | null;
    setValue: (value: T) => void;
};

const VersusScatterChartSelect = <T = null>({
    options,
    value,
    otherValue,
    setValue,
    className,
}: Props<T>) => {
    const ref = useRef(null);
    const [isOpened, setIsOpened] = useState(false);

    const selectedOption = useMemo(
        () => options.find(o => o.id === value),
        [options, value]
    );

    const restOptions = useMemo(
        () => options.filter(o => o.id !== value && o.id !== otherValue),
        [options, value, otherValue]
    );

    useOutsideClick({
        ref,
        callback: () => setIsOpened(false),
    });

    return (
        <div
            ref={ref}
            className={cn(
                "VersusScatterChartSelect",
                className,
                isOpened && 'is-opened',
            )}
        >
            <div
                className="VersusScatterChartSelect__thumbnail"
                onClick={() => setIsOpened(!isOpened)}
            >
                {selectedOption?.title}
                <MdKeyboardArrowDown className="VersusScatterChartSelect__icon"/>
            </div>
            <div className="VersusScatterChartSelect__dropdown">
                {restOptions.map(o => (
                    <div
                        key={o.id as string}
                        className="VersusScatterChartSelect__option"
                        onClick={() => {
                            setIsOpened(false);
                            setValue(o.id);
                        }}
                    >
                        {o.title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VersusScatterChartSelect;